import { FC } from 'react';

import SweetenerComponentListing from 'components/main/SweetenerComponent';

const SweetenerComponent: FC = () => <SweetenerComponentListing />;

export default SweetenerComponent;
